<template>
  <v-dialog :value="value" persistent max-width="680">
    <v-card>
      <v-card-title class="headline">
        {{ $t("payment.confirm_update_title") }}
      </v-card-title>

      <v-card-text>
        <v-alert type="warning" text dense>
          {{ $t("payment.confirm_update_message") }}
        </v-alert>

        <v-simple-table dense class="mb-5 confirmation-table">
          <tbody>
            <tr>
              <th>{{ $t("pre_regis_panel.student_id") }}</th>
              <td>{{ student_id }}</td>
            </tr>
            <tr>
              <th>{{ $t("pre_regis_panel.name_surname") }}</th>
              <td>{{ student_name || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("payment.education_level") }}</th>
              <td>{{ level_name }}</td>
            </tr>
            <tr>
              <th>{{ $t("payment.year") }}</th>
              <td v-if="item">
                {{ item.semester }} / {{ item.year }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("payment.registration_type") }}</th>
              <td>{{ registration_type || "-" }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="subtitle-1 font-weight-medium mb-2">
          {{ $t("payment.change_details") }}
        </div>
        <v-simple-table dense class="mb-5 confirmation-table">
          <thead>
            <tr>
              <th>{{ $t("payment.transaction") }}</th>
              <th class="text-right">{{ $t("payment.current_value") }}</th>
              <th class="text-right">{{ $t("payment.new_value") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="change in changes" :key="change.key">
              <td>{{ change.label }}</td>
              <td class="text-right">
                {{ display_change_value(change, "old") }}
              </td>
              <td
                class="text-right"
                :class="{
                  'font-weight-bold primary--text': !same_value(change),
                }"
              >
                {{ display_change_value(change, "new") }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="subtitle-1 font-weight-medium mb-2">
          {{ $t("payment.current_payment_summary") }}
        </div>
        <v-simple-table dense class="confirmation-table">
          <tbody>
            <tr>
              <th>{{ $t("payment.paid") }}</th>
              <td class="text-right">{{ item ? item.paid : "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("payment.remain") }}</th>
              <td class="text-right">{{ item ? item.remain : "-" }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-alert v-if="!has_changes" class="mt-4 mb-0" type="info" text dense>
          {{ $t("payment.no_changes") }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="pb-5 px-6">
        <v-spacer />
        <v-btn
          color="#ff5722"
          :dark="has_changes"
          depressed
          :loading="loading"
          :disabled="!has_changes"
          @click="$emit('confirm')"
        >
          {{ $t("payment.confirm_and_save") }}
        </v-btn>
        <v-btn
          class="ml-2"
          color="#ff5722"
          outlined
          :disabled="loading"
          @click="$emit('cancel')"
        >
          {{ $t("payment.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PaymentFeeConfirmDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    student_id: {
      type: String,
      required: true,
    },
    student_name: {
      type: String,
      default: "",
    },
    level_name: {
      type: String,
      default: "",
    },
    registration_type: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    changes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    has_changes() {
      return this.changes.some((change) => !this.same_value(change));
    },
  },
  methods: {
    same_value(change) {
      return String(change.old_value) === String(change.new_value);
    },
    display_change_value(change, side) {
      const displayValue = change[`${side}_display`];
      return displayValue == null
        ? this.currency(change[`${side}_value`])
        : displayValue;
    },
    currency(value) {
      const amount = Number(String(value ?? "0").replace(/,/g, ""));
      if (!Number.isFinite(amount)) return "-";
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.confirmation-table th {
  min-width: 180px;
}
</style>
